import { render } from "./ProjectBlock.vue?vue&type=template&id=77f2c96d&scoped=true"
import script from "./ProjectBlock.vue?vue&type=script&lang=js"
export * from "./ProjectBlock.vue?vue&type=script&lang=js"

import "./ProjectBlock.vue?vue&type=style&index=0&id=77f2c96d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f2c96d"]])

export default __exports__